import { apiGet, apiPatch } from './client';
import type { ConfigQuanto, ConfigQuantoBatchRequest } from '../types/ConfigQuanto';

// ConfigQuanto is Central (bank-wide) — NoTenantContext, no X-Tenant-Id needed.
export function getConfigQuanto(): Promise<ConfigQuanto[]> {
  return apiGet<ConfigQuanto[]>('/api/config-quanto');
}

export function saveConfigQuantoBatch(
  added: ConfigQuanto[],
  modified: ConfigQuanto[],
  deletedIds: number[],
): Promise<ConfigQuanto[]> {
  return apiPatch<ConfigQuantoBatchRequest, ConfigQuanto[]>(
    '/api/config-quanto/batch',
    { added, modified, deleted: deletedIds },
  );
}
